import {
  AutoComplete,
  Breadcrumb,
  Input,
  message,
  Pagination,
  Result,
  Space,
} from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  BackIcon,
  CloseIconSearch,
  DelivLogo,
  OrderLogo,
  ReviewLogo,
  SearchIcon,
} from "../../../../asset";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import MapsRoute from "../../../../component/maps/MapsRoute";
import { ROUTES } from "../../../../constant/routeConstant";

import style from "./AllTripAdd.module.css";
import Geocode from "react-geocode";
import _, { update } from "lodash";
import { GROLOG_ORDER_URL, GROLOG_URL } from "../../../../constant/apiConstant";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import CustomTable from "../../../../component/table/CustomTable";
import CustomPaging from "../../../../component/pagination/pagination";
import ModalConfirmLeave from "../../../../component/modal/ModalConfirmLeave";
import ModalSuccessAdd from "../../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../../component/modal/ModalFailedDelete";
import { onChanged } from "../../../../util/Util";
import ModalDetail from "../../../../component/modal/ModalDetail";
import MapsSingle from "../../../../component/maps/MapsSingle";
import Pin from "../../../../asset/PinMaps-Icon.svg";
import { validTrip } from "./validation";

const AddAllTrip = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [page, setPage] = useState(1);
  const [pageDeliv, setPageDeliv] = useState(1);
  const [form, setForm] = useState({});
  const [directions, setDirections] = useState({});
  const [directions1, setDirections1] = useState({});
  const [directions2, setDirections2] = useState({});

  const [directions3, setDirections3] = useState({});
  const [filter, setFilter] = useState("");
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchRecommendation, setSearchRecommedation] = useState();
  const [listRecommendation, setListRecommendation] = useState([]);
  const [searchRecommendation2, setSearchRecommedation2] = useState();
  const [listRecommendation2, setListRecommendation2] = useState([]);
  const [initiate, setInitiate] = useState([]);
  const [limit, setLimit] = useState(10);
  const [initiates, setInitiates] = useState([]);
  const [delivAso, setDelivAso] = useState([]);
  const [listDeliv, setListDeliv] = useState([]);
  const [list, setList] = useState([]);
  const [filter2, setFilter2] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState(1);
  const [messages, setMessages] = useState("");
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [change, setChange] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [detailId, setDetailId] = useState();
  const [detail, setDetail] = useState([]);
  const [detailDepot, setDetailDepot] = useState();
  const [error, setError] = useState([]);
  const [isDetailModal, setIsDetailModal] = useState(false);
  const [messagesDetail, setMessagesDetail] = useState("");
  // const [card,setCard] = useState()

  const dispatch = useDispatch();
  const [pageMap, setPageMap] = useState(1);
  const [changePage, setChangePage] = useState(false)
  const [loadMaps, setLoadMaps] = useState(false)
  const [pageOrder, setPageOrder] = useState(1)
  const [limitOrder, setLimitOrder] = useState(100)
  // const [setLimitMap, setLimitMap] = useState(25)

  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  const location = useLocation();
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;
  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const removeDuplicateObjects = (array, uniqueProperty) => {
    const filteredArray = [];
    const uniqueValues = [];

    for (let i = 0; i < array.length; i++) {
      const currentObject = array[i];
      const uniqueValue = currentObject[uniqueProperty];

      if (!uniqueValues.includes(uniqueValue)) {
        filteredArray.push(currentObject);
        uniqueValues.push(uniqueValue);
      }
    }

    return filteredArray;
  };


  const fetchData = async (data, pages, isSearch) => {
    let id = 1;
    let resDepot = await doGets(
      `/depot-configuration/${location.state}?${param}`,
      token
    );
    setDetailDepot(resDepot?.data?.payload?.data);
    let res = await doGet(
      `/order-all-trip?page=${
        pages ? pages : pageOrder
      }&limit=${limitOrder}&filter=depot_id eq ${location.state}${
        filter
          ? ", order_number lk " + filter
          : data
          ? ", order_number lk " + data
          : ""
      }&${param}`,
      token
    );
    let init = await doGet(
      `/order-all-trip/initiate?page=${
        pages ? pages : pageOrder
      }&limit=${limitOrder}&filter=depot_id eq ${location.state}${
        filter
          ? ", order_number lk " + filter
          : data
          ? ", order_number lk " + data
          : ""
      }&${param}`,
      token
    );
    setInitiate(init?.data?.payload?.data);
    let datas = [];
//delivery associate
let result = await doGets(
  `/delivery-associate?page=${
    pageDeliv
  }&limit=${limit}&order=id asc&filter=depot_id eq ${
    location.state
  }, status eq Active&${param}`,
  token
);
let inits = await doGets(
  `/delivery-associate/initiate?page=${
    pageDeliv
  }&limit=${limit}&order=id asc&filter=depot_id eq ${
    location.state
  }&${param}`,
  token
);
setListDeliv(result?.data?.payload?.data);
setInitiates(inits?.data?.payload?.data);
    const idSet1 = new Set(res?.data?.payload?.data.map((obj) => obj.order_id));
    const idSet2 = new Set(cards.map((obj) => obj.order_id));

    const intersection = [...idSet1].filter((order_id) => idSet2.has(order_id));
    console.log("inter", intersection);
    if (intersection.length > 0) {
      const isIDInArray = (order_id) => {
        return intersection.includes(order_id);
      };

      // Iterate over the arrayOfObjects and splice objects with matching IDs
      for (let i = res?.data?.payload?.data.length - 1; i >= 0; i--) {
        const obj = res?.data?.payload?.data[i];
        if (isIDInArray(obj.order_id)) {
          res?.data?.payload?.data.splice(i, 1);
        }
      }

      console.log("after splicee", res?.data?.payload?.data);
      res?.data?.payload?.data?.map((el, i) => {
        datas.push({
          address: el?.address,
          longitude: Number(el?.longitude),
          latitude: Number(el?.latitude),
          order_id: el?.order_id,
          order_number: el?.order_number,
          status: el?.status,
          customer_name: el?.customer_name,
          disSubdis: el.district_name + "-" + el?.sub_district_name,
        });
      });
      const uniqueArray = removeDuplicateObjects(datas, "order_id");
      if(isSearch){
      setList([...list,...uniqueArray]);
      }else{
        setList([...uniqueArray])
      }
    }
    res?.data?.payload?.data?.map((el, i) => {
      datas.push({
        address: el?.address,
        longitude: Number(el?.longitude),
        latitude: Number(el?.latitude),
        order_id: el?.order_id,
        order_number: el?.order_number,
        status: el?.status,
        customer_name: el?.customer_name,
        disSubdis: el.district_name + "-" + el?.sub_district_name,
      });
    });

    const uniqueArray = removeDuplicateObjects(datas, "order_id");

    if(isSearch){
      setList([...list,...uniqueArray]);
      }else{
        setList([...uniqueArray])
      }

    
  };

  useEffect(() => {
    fetchData();
    
    // if(card.length === 2 && window.google){
    //   directionToMaps2(1)
    // }if(card.length === 3 && window.google){
    //   directionToMaps2(2)
    // }
  }, [filter, pageDeliv]);

  useEffect(()=>{
    if (cards.length !== 0 && window.google) {
      let sisa = cards.length%25
      let getpage =Math.floor(cards.length/25)
      if(getpage ===0){
        directionToMaps(1);
      }else if(getpage >0 && sisa>0){
        directionToMaps(getpage+1);
      }else if(getpage >0 && sisa===0){
        directionToMaps(getpage);
      }
      let cks = [];

      // cks.push(cards.splice(0, chunkSize));
      // setPageMap(cards.length<=25 ? 1 : cards.length<=50&&cards.length>25 ? 2 : cards.length<=75&&cards.length>50 ? 3 :4)
    }
    // if (window.google) {
    //   directionToMaps(pageMap);
    // }
  },[cards])

  // const directionsService = new window.google.maps.DirectionsService();
  // result?.map((el, index) => {
  //   directionsService.route(
  //     {
  //       origin: index === 0 ?
  //        { lat: Number(detailDepot?.depot_profile?.depot_latitude),
  //         lng: Number(detailDepot?.depot_profile?.depot_longitude),
  //         } :
  //       {lat: Number(card[index].latitude),
  //         lng: Number(card[index].longitude),
  //       },
  //       destination: index === 0 ? {lat: cards[cards?.length - 1]?.latitude,
  //         lng: cards[cards?.length - 1]?.longitude,} :
  //         {
  //           lat: card[index]?.latitude,
  //           lng: card[index]?.longitude,
  //         },
  //       waypoints: el,
  //       optimizeWaypoints: true,
  //       travelMode: window.google.maps.TravelMode.DRIVING,
  //       // avoidHighways:true,
  //     },
  //     (result, status) => {
  //       if (status === window.google.maps.DirectionsStatus.OK) {
  //         console.log("index ke:",index,`sini kesiniiii`, result);
  //       }
  //     }
  //   );
  // });

  // generateMapPer10(way, destination)

  // console.log("wpts", way)
  // console.log("dest", destination);;
  // console.log("check way 2", way);

  // const directionToMaps = () => {
  //   setLoading(true);
  //   // Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
  //   let waypts = [];
  //   for (let i = 1; i < cards?.length - 1; i++) {
  //     let loc = {
  //       location: new window.google.maps.LatLng(
  //         cards[i]?.latitude,
  //         cards[i]?.longitude
  //       ),
  //       stopover: true,
  //     };
  //     waypts.push(loc);
  //   }
  //   let ways = [];
  //   cards?.map((el, i) => {
  //     ways.push({
  //       location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
  //       stopover: true,
  //     });
  //   });
  //   let resu=[]
  //   let card = []
  //   while (ways?.length) {
  //     resu.push(ways?.splice(0, 25));
  //   }

  //   let cardd = []
  //   while (tempArray.length) {
  //     cardd.push(tempArray.splice(0, chunkSize));
  //   }
  //   // console.log("pesss", way);
  //   const directionsService = new window.google.maps.DirectionsService();
  //   // const directionsRenderer = new window.google.maps.DirectionsRenderer();

  //   // const originIcon = {
  //   //   url: 'https://gromart.blob.core.windows.net/gromatedisk/icon.png', // Replace with the path to your custom origin icon
  //   //   scaledSize: new window.google.maps.Size(50, 50), // Adjust the size of the icon
  //   // };

  //   const origin = {
  //     lat: Number(detailDepot?.depot_profile?.depot_latitude),
  //     lng: Number(detailDepot?.depot_profile?.depot_longitude),
  //   };
  //   // const destination = {
  //   //   lat: cardd[0][cardd[0]?.length - 1]?.latitude,
  //   //   lng: cardd[0][cardd[0]?.length - 1]?.longitude,
  //   // };

  //   const destination = {
  //     lat: cards[24]?.latitude,
  //     lng: cards[24]?.longitude,
  //   };
  //   console.log("waypts", waypts);
  //   directionsService.route(
  //     {
  //       origin: origin,
  //       destination: destination,
  //       waypoints: resu[0],
  //       optimizeWaypoints: true,
  //       travelMode: window.google.maps.TravelMode.DRIVING,
  //       // avoidHighways:true,
  //     },
  //     (result, status) => {
  //       if (status === window.google.maps.DirectionsStatus.OK) {
  //         // directionsRenderer.setDirections(result);
  //         // const originMarker = new window.google.maps.Marker({
  //         //   position: origin,
  //         //   icon: originIcon,
  //         // });
  //         setDirections(result);
  //         console.log("sini", result);
  //         // createMarkersForWaypoints(result);
  //       }
  //     }
  //   );
  //   setLoading(false);
  // };
  const results = [];
  const chunkSize = 25;
  const tempArray = [...cards];
  // let way = [];
  let waypts = [];
  let way = [];
  const directionsService = new window.google.maps.DirectionsService();

  cards?.map((el, i) => {
    way.push({
      location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
      stopover: true,
    });
  });

  while (way.length) {
    results.push(way.splice(0, chunkSize));
  }

  let card = [];
  while (tempArray.length) {
    card.push(tempArray.splice(0, chunkSize));
  }
  
  const directionToMaps = (pg) => {
    
  console.log("DISINI CHECK", cards, pageMap,card[pg - 1],card[pageMap - 1], pg);
    setLoading(true);
    setLoadMaps(true)
    Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    let way = [];
    cards?.map((el, i) => {
      way.push({
        location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
        stopover: true,
      });
    });
    let resu = [];
    console.log("pesss", waypts);
    const directionsService = new window.google.maps.DirectionsService();
    // const directionsRenderer = new window.google.maps.DirectionsRenderer();

    // const originIcon = {
    //   url: 'https://gromart.blob.core.windows.net/gromatedisk/icon.png', // Replace with the path to your custom origin icon
    //   scaledSize: new window.google.maps.Size(50, 50), // Adjust the size of the icon
    // };

    // const origin = {
    //   lat: Number(detailDepot?.depot_profile?.depot_latitude),
    //   lng: Number(detailDepot?.depot_profile?.depot_longitude),
    // };
    // const destination = {
    //   lat: cards[cards?.length - 1]?.latitude,
    //   lng: cards[cards?.length - 1]?.longitude,
    // };
    console.log("waypts", pg);
    directionsService.route(
      {
        origin:
          pg === 1
            ? {
                lat: Number(detailDepot?.depot_profile?.depot_latitude),
                lng: Number(detailDepot?.depot_profile?.depot_longitude),
              }
            : {
                lat: Number(card[pg - 2][card[pg - 2]?.length - 1].latitude),
                lng: Number(card[pg - 2][card[pg - 2]?.length - 1].longitude),
              },
        destination:
        pg > 1
            ? {
                lat: card[pg - 1][card[pg - 1]?.length - 1]?.latitude,
                lng: card[pg - 1][card[pg - 1]?.length - 1]?.longitude,
              }
            : {
                lat: cards[cards?.length - 1]?.latitude,
                lng: cards[cards?.length - 1]?.longitude,
              },

        waypoints: results[pg - 1],
        optimizeWaypoints: true,
        travelMode: window.google.maps.TravelMode.DRIVING,
        // avoidHighways:true,
      },
      (result, status) => {
        console.log("check status", status);
        console.log("check result", result.status);
        if(result?.status === "ZERO_RESULTS"){
console.log("berhasil kesini");
setLoadMaps(true)
        }
        else if (status === window.google.maps.DirectionsStatus.OK) {
          setDirections(result);
          console.log("sini", result);
          console.log("berhasil kesini 2");
        }
      }
    );
    setLoading(false);
    setLoadMaps(false)
  };

  // setCard(card)

  const directionToMaps2 = (index) => {
    setLoading(true);
    // let datas
    // card[index]?.map((el, i) => {
    //   way.push({
    //     location: new window.google.maps.LatLng(el?.latitude, el?.longitude),
    //     stopover: true,
    //   });
    // });
    console.log("index", index);
    console.log("check waypts", results);
    console.log("werew", results[index]);
    // Geocode.setApiKey("AIzaSyC3m-M8TJAIH96lzjN2gDXHpyO1A2tTbsk");
    console.log("isinya apa", cards[cards?.length - 1]?.latitude);
    console.log("check isinya", card[index][card[index]?.length - 1]?.latitude);
    directionsService.route(
      {
        origin:
          cards?.length <= 25
            ? {
                lat: Number(detailDepot?.depot_profile?.depot_latitude),
                lng: Number(detailDepot?.depot_profile?.depot_longitude),
              }
            : {
                lat: Number(cards[24].latitude),
                lng: Number(cards[24].longitude),
              },
        destination:
          cards?.length <= 25
            ? {
                lat: cards[cards?.length - 1]?.latitude,
                lng: cards[cards?.length - 1]?.longitude,
              }
            : {
                lat: card[index][card[index]?.length - 1]?.latitude,
                lng: card[index][card[index]?.length - 1]?.longitude,
              },
        waypoints: results[index],
        optimizeWaypoints: true,
        travelMode: window.google.maps.TravelMode.DRIVING,
        // avoidHighways:true,
      },
      (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          console.log("index ke:", index, `sini kesiniiii`, result);
          // if(index===1){
          setDirections(result);
          console.log("disini res", result);
          // }if(index===2){
          //   setDirections2(result)
          // }if(index===3){
          //   setDirections3(result)
          // }
        }
      }
    );
    setLoading(false);
  };
  console.log("eeeeeee", directions);

  const draggingItem = useRef();
  const dragOverItem = useRef();
  const handleDragStart = (e, position) => {
    draggingItem.current = position;
    console.log(e.target.innerHTML);
  };

  const handleDragEnter = (e, position) => {
    dragOverItem.current = position;
    console.log(e.target.innerHTML);
    const listCopy = [...cards];
    console.log(draggingItem.current, dragOverItem.current);
    const draggingItemContent = listCopy[draggingItem.current];
    listCopy.splice(draggingItem.current, 1);
    listCopy.splice(dragOverItem.current, 0, draggingItemContent);

    draggingItem.current = dragOverItem.current;
    dragOverItem.current = null;
    setCards(listCopy);
    directionToMaps(pageMap);
  };

  const joinCard = async (el, i) => {
    if(cards.length<100){
    onChanged(dispatch, true);
    setChange(true);
    setLoading(true);
    let newDetail = list;
    newDetail.splice(i, 1);
    setCards([...cards, el]);
    console.log("nwee", newDetail);
    setList(newDetail);
    let getLngth = [...cards, el];
    // if(!changePage){
    setPageMap(
      getLngth?.length <= 25
        ? 1
        : getLngth?.length <= 50 && getLngth?.length > 25
        ? 2
        : getLngth?.length <= 75 && getLngth?.length > 50
        ? 3
        : 4
    );
    // }

    // directionToMaps(getLngth?.length <= 25
    //   ? 1
    //   : getLngth?.length <= 50 && getLngth?.length > 25
    //   ? 2
    //   : getLngth?.length <= 75 && newDetail.length > 50
    //   ? 3
    //   : 4);
    setLoading(false);
    }else{
      setFailedModalOpen(true)
      setMessages("Order must less or equal than 100")
    }
  };
console.log("cek perubahan",changePage);
  const removeCard = (el, i) => {
    onChanged(dispatch, true);
    setChange(true);
    setLoading(true);
    setList([...list, el]);
    let newDetail = [...cards];
    let idx = cards.findIndex((item) => item.order_id === el?.order_id);
    newDetail.splice(idx, 1);
    setCards(newDetail);

    let getLngth = newDetail;
    if(i===cards?.length-1){
      setLoadMaps(false)
    }
    // if(!changePage){
    setPageMap(
      getLngth?.length <= 25
        ? 1
        : getLngth?.length <= 50 && getLngth?.length > 25
        ? 2
        : getLngth?.length <= 75 && newDetail.length > 50
        ? 3
        : 4
    );
    // }
    // directionToMaps(getLngth?.length <= 25
    //   ? 1
    //   : getLngth?.length <= 50 && getLngth?.length > 25
    //   ? 2
    //   : getLngth?.length <= 75 && newDetail.length > 50
    //   ? 3
    //   : 4);
    setLoading(false);
  };

  const onSearchRecommendation = async (value) => {
    setSearchRecommedation(value);
    // setIsfilter(true)
    if (value) {
      setSearchRecommedation(value);
      await fetchRecommendation(1, 10, value);
    } else {
    }
  };

  const onSearchRecommendation2 = async (value) => {
    setSearchRecommedation2(value);
    // setIsfilter(true)
    if (value) {
      setSearchRecommedation2(value);
      await fetchRecommendation2(value);
    } else {
    }
  };

  console.log("222222", listRecommendation2);

  const onSelectRecommendation = (data) => {
    setPage(1);
    setFilter(data);
    fetchData(data, 1);
    // setIsfilter(false)
    setListRecommendation("");
  };

  const onSelectRecommendation2 = (data) => {
    // fetchData2(data, 1);
    // setIsfilter(false)
    setFilter2(data);
    setListRecommendation2("");
  };

  const onClearRecommendation = (e) => {
    // setIsfilter(false);
    setFilter(null);
    setInitiate([]);
    setSearchRecommedation("");
    setListRecommendation("");
    fetchData("", 1);
  };

  const onClearRecommendation2 = (e) => {
    // setIsfilter(false);
    setFilter2("");
    setSearchRecommedation2("");
    setListRecommendation2("");
    // fetchData("", 1);
  };

  const fetchRecommendation = async (
    page,
    limit,
    filters,
    mapping_principal_id
  ) => {
    if (filters.length >= 1) {
      let res = await doGet(
        `/order-all-trip/search?page=1&limit=10&filter=depot_id eq ${location.state}, order_number lk ${filters}&${param}`,
        token
      );
      setListRecommendation(res?.data?.payload?.data);
    }
  };

  const fetchRecommendation2 = (filters) => {
    console.log("fil", filters);
    if (filters.length >= 1) {
      const filteredObjects = cards.filter((obj) =>
        obj.customer_name.toLowerCase().startsWith(filters.toLowerCase())
      );
      setListRecommendation2(filteredObjects);
    }
  };

  const onScrollCard = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      // setLoading(true);
      console.log("sini g");
      setPageOrder(pageOrder + 1);
      target.scrollTo(0, target.scrollHeight);
      // getListProvince(form?.depot_country, pageProvince, limitProvince, "");
      // setTimeout(() => {
        
    fetchData(filter, pageOrder + 1, true);
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };
console.log("cek loading", loading);
console.log("cek loading map", loadMaps);
  const cardSelect = (el, index) => {
    return (
      <>
        <div className="max-w-[716px] border-2 rounded-md bg-white-100 border-gray-200 h-[100px] mt-2 cursor-move">
          <div className="flex justify-between items-center">
            <div
              className="w-[85%] flex"
              onDragStart={(e) => handleDragStart(e, index)}
              onDragOver={(e) => e.preventDefault()}
              onDragEnter={(e) => handleDragEnter(e, index)}
              key={index}
              draggable
            >
              <div className="w-[10%] justify-center mt-7 ml-3 font-roboto font-medium">
                {el?.order_id}
              </div>
              <div className="w-[90%] mt-3">
                <div className="flex">
                  <div className="font-roboto-medium text-lg text-[#818181]">
                    {el.order_number}
                  </div>
                  <div
                    className={`${
                      el?.status === "New" ? "bg-red-100" : "bg-[#5A005A]"
                    } px-2 rounded-3xl w-auto ml-3`}
                  >
                    <p className=" font-roboto-medium text-lg font-normal text-white-100">
                      {el?.status}
                    </p>
                  </div>
                </div>
                <div className="font-font-roboto-medium text-lg">
                  {el.disSubdis}
                </div>
              </div>
            </div>
            <div className="w-15%">
              <div className="mt-3 ml-12">
                <img
                  src={CloseIconSearch}
                  alt="close"
                  className={loading ? "cursor-not-allowed" : "cursor-pointer"}
                  onClick={loading ? "":() => removeCard(el, index)}
                />
              </div>
              <div
                onClick={() => setModal(el?.order_id, 0)}
                className="mt-2 mr-2 font-roboto font-normal text-sm text-red-100"
              >
                view detail
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const handleChange = (value, name) => {
    onChanged(dispatch, true);
    setChange(true);
    let eror = validTrip(name, value.target.value, t);
    setError({ ...error, ...eror });
    setForm((prevsValue) => {
      return {
        ...prevsValue,
        [name]: value.target.value,
      };
    });
  };

  const setModal = async(orderId, tripId) => {
    try{
    let res = await doGet(
      `${
        tripId !== 0
          ? `/all-trip/trip-route/${tripId}?${param}`
          : `/order/${orderId}?${param}`
      }`,
      token
    );
      setDetail(res?.data?.payload?.data);
      setOpenDetail(true);
    }catch(err){
  setMessagesDetail(err.response.data.payload.message);
      setIsDetailModal(true);
    }
    // setDetail(res?.data?.payload?.data);
    // console.log("sini 1");
    // console.log("status result", res);
    // if (res?.status === 200) {
    //   setDetail(res?.data?.payload?.data);
    //   setOpenDetail(true);
    //   console.log("berhasil");
    // } else {
    //   console.log("gagal", res);

    //   setMessagesDetail(res?.message);
    //   setIsDetailModal(true);
    // }
  };

  const page1 = () => {
    return (
      <>
        <div>
          <div className="flex mt-3">
            {/* line one */}
            <div className="gap-[40px] mb-[24px]">
              <div className="w-[500px] mb-[24px]">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("Order Detail")}
                </h3>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Trip Name")}
                </label>
                <Input
                  value={form?.trip_name}
                  className="mt-[8px] h-[47px] w-[500px] ml-2"
                  onChange={(value) => handleChange(value, "trip_name")}
                  status={error?.trip_name ? "error" : ""}
                  // onChange={(value) => handleChange(value, "depot_name")}
                />
                <div className="text-red-100">{error?.trip_name}</div>
              </div>

              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Trip Number") + " (Optional)"}
                </label>
                <Input
                  className="mt-[8px] h-[47px] w-[500px] ml-2"
                  onChange={(value) => handleChange(value, "trip_number")}
                />
              </div>
            </div>
            {/* line two */}

            <div className="gap-[40px] mb-[24px] ml-32 mt-14">
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Trip ID")}
                </label>
                <Input
                  className="mt-[8px] h-[47px] w-[500px] ml-2"
                  disabled
                  // onChange={(value) => handleChange(value, "depot_name")}
                />
              </div>
            </div>
          </div>
          <div className="w-full ml-[20px]">
            {cards.length === 0 ? (
              <MapsSingle
                long={Number(detailDepot?.depot_profile?.depot_longitude)}
                lat={Number(detailDepot?.depot_profile?.depot_latitude)}
                trip={true}
              />
            ) : (
              <>
                <MapsRoute
                  data={cards}
                  datas={card[pageMap - 1]}
                  directions={directions}
                  paging={pageMap}
                  // directions1={directions1}
                  // directions2={directions2}
                  // directions3={directions3}
                  long={
                    pageMap === 1
                      ? Number(detailDepot?.depot_profile?.depot_longitude)
                      : Number(
                          card[pageMap - 2][card[pageMap - 2]?.length - 1]
                            .longitude
                        )
                  }
                  lat={
                    pageMap === 1
                      ? Number(detailDepot?.depot_profile?.depot_latitude)
                      : Number(
                          card[pageMap - 2][card[pageMap - 2]?.length - 1]
                            .latitude
                        )
                  }
                />
                <div
                  id={"pageMap"}
                  className={style.Wrap + " justify-end flex"}
                >
                  <div className="font-semibold text-base text-[#1D1D1D]">
                    {card[pageMap - 1].length} Of {cards.length} Order
                  </div>
                  <Pagination
                    // {...props}
                    // size="small"
                    onShowSizeChange={false}
                    current={pageMap}
                    defaultCurrent={pageMap}
                    pageSize={25}
                    total={cards?.length}
                    // pageSizeOptions={initiate && initiate?.valid_limit}
                    // onShowSizeChange={() => handlePaginationMap()}
                    onChange={(value) => handlePaginationMap(value, 25)}
                  />
                </div>
                {/* <div >
            <CustomPaging
              idLimit="ddlrowsperpagemap"
              idPagination="btnpaginationmap"
              size="small"
              current={pageMap}
              defaultCurrent={pageMap}
              pageSize={25}
              total={cards?.length}
              // pageSizeOptions={25}
              onShowSizeChange={() => handlePaginationMap()}
              handlePaging={(a, b) => handlePaginationMap(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div> */}
              </>
            )}
          </div>
          {/* drag and drop */}
          <div className="flex">
            <div className="ml-4 mt-2">
              <div className="w-[500px] mb-[24px] ">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("List Order")}
                </h3>
              </div>
              <div
                className={
                  style.headerContainer + " flex justify-between items-center"
                }
              >
                <div className="flex h-[47px] w-[500px] ">
                  <AutoComplete
                    options={
                      listRecommendation &&
                      listRecommendation?.map((item) => ({
                        value: item.value,
                        label: item.value,
                      }))
                    }
                    value={searchRecommendation}
                    onChange={(value) => onSearchRecommendation(value)}
                    onSelect={(value) => onSelectRecommendation(value)}
                  >
                    <Input
                      placeholder={t("Search Trip Id or Name")}
                      suffix={
                        <img
                          src={filter ? CloseIconSearch : SearchIcon}
                          alt="search"
                          onClick={
                            filter ? () => onClearRecommendation() : null
                          }
                        />
                      }
                      // value={searchRecommendation}
                      width={500}
                      className="w-[500px] h-[47px]"
                    />
                  </AutoComplete>
                </div>
              </div>
              {/* cards */}
              <div
                id="scrollableDiv"
                style={{
                  height: "50vh",
                  overflow: "auto",
                  padding: 4,
                  marginTop: 2,
                  // padding: "0 12px",
                  // marginLeft: -12,
                }}
                onScroll={(e) =>onScrollCard(e)}
              >
                {list?.map((el, index) => {
                  return (
                    <>
                      <div className="max-w-[716px] border-2 shadow-[0px 4px 4px rgba(0, 0, 0, 0.25)] rounded-md bg-white-100 border-gray-200 h-[100px] mt-2 cursor-pointer">
                        <div className="flex justify-between items-center">
                          <div
                            className={loadMaps ? "w-[85%] flex cursor-not-allowed" :"w-[85%] flex cursor-pointer"}
                            onClick={loadMaps ? "":() => joinCard(el, index)}
                          >
                            <div className="w-[10%] justify-center mt-7 ml-3 font-roboto font-medium">
                              {el?.order_id}
                            </div>
                            <div className="w-[90%] mt-3">
                              <div className="flex">
                                <div className="font-roboto-medium text-lg text-[#818181]">
                                  {el.order_number}
                                </div>
                                <div
                                  className={`${
                                    el?.status === "New"
                                      ? "bg-red-100"
                                      : "bg-[#5A005A]"
                                  } px-2 rounded-3xl w-auto ml-3`}
                                >
                                  <p className=" font-roboto-medium text-lg font-normal text-white-100">
                                    {el?.status}
                                  </p>
                                </div>
                              </div>
                              <div className="font-font-roboto-medium text-lg">
                                {el.disSubdis}
                              </div>
                            </div>
                          </div>
                          <div className="w-[15%]">
                            <div className="mt-3"></div>
                            <div
                              onClick={() => setModal(el?.order_id, 0)}
                              className=" font-roboto font-normal text-sm text-red-100"
                            >
                              view detail
                            </div>
                          </div>
                        </div>
                        {/* tes {el?.trip_route_id}
                        {el?.address} */}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <div className="ml-10 mt-2">
              <div className="w-[500px] mb-[24px] ">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("List Selected")}
                </h3>
              </div>
              <div
                className={
                  style.headerContainer + " flex justify-between items-center"
                }
              >
                <div className="flex h-[47px] ">
                  <AutoComplete
                    // options={options}
                    options={
                      listRecommendation2 &&
                      listRecommendation2?.map((item) => ({
                        value: item.customer_name,
                        label: item.customer_name,
                      }))
                    }
                    value={searchRecommendation2}
                    onChange={(value) => onSearchRecommendation2(value)}
                    onSelect={(value) => onSelectRecommendation2(value)}
                    //  allowClear={true}
                  >
                    <Input
                      placeholder={t("Search Trip Id or Name")}
                      suffix={
                        <img
                          src={filter2 ? CloseIconSearch : SearchIcon}
                          alt="search"
                          onClick={
                            filter2 ? () => onClearRecommendation2() : null
                          }
                        />
                      }
                      // value={searchRecommendation}
                      // width={716}
                      className="w-[500px] h-[47px]"
                    />
                  </AutoComplete>
                </div>
              </div>
              {/* cards */}
              <div
                id="scrollableDiv"
                style={{
                  height: "50vh",
                  overflow: "auto",
                  marginTop: 3,
                  // padding: "0 12px",
                  // marginLeft: -12,
                }}
                // onScroll={(e) => onScrollCard(e)}
              >
                {filter2 !== ""
                  ? cards
                      .filter((obj) =>
                        obj.customer_name
                          .toLowerCase()
                          .startsWith(filter2.toLowerCase())
                      )
                      .map((el, index) => {
                        return <>{cardSelect(el, index)}</>;
                      })
                  : cards?.map((el, index) => {
                      return <>{cardSelect(el, index)}</>;
                    })}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const api = GROLOG_ORDER_URL;
    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const validateSubmit = (error) => {
    for (const key in error) {
      if (Object.hasOwnProperty.call(error, key)) {
        if (error[key]) return false;
      }
    }
    return true;
  };

  const handleNext = async () => {
    let errors = {};
    let datas = {
      trip_name: form?.trip_name ? form?.trip_name : "",
    };
    let sub = {
      depot_id: location.state,
      list_order: cards?.map((el) => el?.order_id),
    };
    for (const key in datas) {
      const option = validTrip(key, datas[key], t);
      // let option = validUserProfile(key, value[key], this.props.t);
      const currentError = option;
      errors = { ...currentError, ...errors };
    }
    setError(errors);
    console.log("errore", errors);
    if (validateSubmit(errors)) {
      try {
        let tkn = token;
        let res = await doPost(
          `/all-trip/order-trip/route?${param}`,
          token,
          sub
        );
        // setSuccessModalOpen(true);
        // message.success(_.startCase(res.data.payload.message));
        setPage(2);
      } catch (err) {
        if (
          err.response.data.payload.message ===
          "Data with this Additional Name is already used by other, cant process this action"
        ) {
          // setErr(err.response.data.payload.message)
        } else {
          // message.error(_.startCase(err.response.data.payload.message));
          setMessages(err.response.data.payload.message);
          setFailedModalOpen(true);
        }
      }
    }
  };

  const handleNext2 = async () => {
    let sub = {
      depot_id: location.state,
      list_order: cards?.map((el) => el?.order_id),
      delivery_associate_id: selectedRowKeys,
    };
    try {
      let tkn = token;
      let res = await doPost(
        `/all-trip/order-trip/delivery_associate?${param}`,
        token,
        sub
      );
      // setSuccessModalOpen(true);
      // message.success(_.startCase(res.data.payload.message));
      setDelivAso(res?.data?.payload?.data);
      setPage(3);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
      }
    }
  };

  const onSubmit = async () => {
    let sub = {
      depot_id: location.state,
      // list_order: cards?.map((el) => el?.order_id),
      trip_name: form?.trip_name,
      trip_number: form?.trip_number,
      delivery_associate_id: selectedRowKeys,
      ...delivAso,
    };
    try {
      let tkn = token;
      let res = await doPost(
        `/all-trip/order-trip/insert?${param}`,
        token,
        sub
      );
      // setSuccessModalOpen(true);
      // message.success(_.startCase(res.data.payload.message));
      setSuccessModalOpen(true);
      // setDelivAso(res?.data?.payload?.data);
      // setPage(3);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
      }
    }
  };

  const ListColumn = [
    {
      title: (
        <div style={{ display: "flex", width: "auto" }}>
          <div style={{ width: "60%" }}>
            <span className="font-roboto text-lg text-[#222222] font-medium">
              {t("Delivery Associate ID")}
            </span>
          </div>
        </div>
      ),
      dataIndex: "id",
      key: "id",
      // sorter: {
      //   compare: (a, b) => a.id.localeCompare(b.id),
      // },
      render: (id) => <span>{id}</span>,
    },

    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Driver Name")}
        </span>
      ),
      dataIndex: "name",
      key: "name",
      render: (name) => <span>{name}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Phone")}
        </span>
      ),
      dataIndex: "phone",
      key: "phone",
      render: (phone) => <span>{phone}</span>,
    },
    {
      title: (
        <span className="font-roboto text-lg text-[#222222] font-medium">
          {t("Vehicle")}
        </span>
      ),
      dataIndex: "vehicle",
      key: "vehicle",
      render: (vehicle) => vehicle,
    },
  ];

  const dataSource = listDeliv
    ? listDeliv.map((result) => ({
        id: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.delivery_associate_id}
          </span>
        ),
        name: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.first_name}
          </span>
        ),
        phone: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.phone}
          </span>
        ),
        vehicle: (
          <span className="font-roboto text-lg text-[#222222]">
            {result?.vehicle_type}
          </span>
        ),
      }))
    : null;

  const handlePagination = (a, b) => {
    if (a && b) {
      setPageDeliv(a);
      setLimit(b);
    } else {
    }
  };

  const handlePaginationMap = (a, b) => {
    if (a && b) {
      setPageMap(a);
      setChangePage(true)
      directionToMaps(a);
      // setLimitMap(b);
    } else {
    }
  };

  const handleRowClick = (record) => {
    console.log("rowww", record.id.props.children);
    // const selectedKeys = selectedRowKeys
    // const index = selectedKeys.indexOf(record.id);

    // if (index === -1) {
    //   // Add the row key to the selectedRowKeys
    //   selectedKeys.push(record.id);
    // } else {
    //   // Remove the row key from the selectedRowKeys
    //   selectedKeys.splice(index, 1);
    // }

    setSelectedRowKeys(record.id.props.children);
  };

  const rowClassName = (record) => {
    console.log("rec", record);
    console.log("select row", selectedRowKeys);
    // Check if the row key is in the selectedRowKeys
    return selectedRowKeys === record.id.props.children
      ? "bg-[#F3BABC] " + style.hoverableRow
      : style.hoverableRow;
  };

  const page2 = () => {
    return (
      <>
        <div className={style.tableContainer + " mt-10"}>
          <CustomTable
            rowClassName={(rec) => rowClassName(rec)}
            columns={ListColumn}
            data={dataSource}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
          />
          <div className={style.containerPagination + " mt-[-45px]"}>
            <CustomPaging
              idLimit="ddlrowsperpagemustselllist"
              idPagination="btnpaginationmustselllist"
              size="small"
              current={pageDeliv}
              defaultCurrent={pageDeliv}
              pageSize={limit}
              total={initiates && initiates?.count_data}
              pageSizeOptions={initiates && initiates?.valid_limit}
              onShowSizeChange={() => handlePagination()}
              handlePaging={(a, b) => handlePagination(a, b)}
              title={t("COMMON:ROW_PAGE")}
            />
          </div>
        </div>

        {/* : "...loading"} */}
      </>
    );
  };

  const page3 = () => {
    return (
      <>
        <div className="flex ml-10 mt-5">
          <div>
            <h3 className="font-roboto text-lg font-medium mb-6 mt-2">
              {t("Trip Detail")}
            </h3>
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Order")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.total_order}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Left Capacity Weight")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.left_capacity_weight}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Kg"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Left Capacity Volume")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.left_capacity_volume}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="M2"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Left Capacity Unit")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.left_capacity_unit}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Trip Distance")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_trip_distance}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Km"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Cost")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="IDR"
                      disabled
                    />
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_cost}
                    />
                  </Space.Compact>
                </div>
              </div>
              {/* Line two */}
              <div className="gap-[40px] mb-[24px] ml-20">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Customer")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.total_customer}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Weight of Trip")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_weight_of_trip}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Kg"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Volume of Trip")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_volume_of_trip}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="M2"
                      disabled
                    />
                  </Space.Compact>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Unit of Trip")}
                  </label>
                  <Input
                    className="mt-[8px] h-[47px] w-[500px]"
                    placeholder="Type Item Brand"
                    value={delivAso.total_unit_of_trip}
                    disabled
                  />
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-base font-medium">
                    {t("Total Estimation Time")}
                  </label>
                  <Space.Compact>
                    <Input
                      style={{
                        width: "480px",
                        height: "47px",
                        marginTop: "8px",
                      }}
                      disabled
                      value={delivAso?.total_estimation_time}
                    />
                    <Input
                      style={{ width: "15%", marginTop: "8px" }}
                      value="Min"
                      disabled
                    />
                  </Space.Compact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setMessages("");
    setIsDetailModal(false);
    setMessagesDetail("");
  };

  // const actModalDetail = () => {
  //   setSuccessModalOpen(false);
  //   setFailedModalOpen(false);
  //   setMessages("");
  // };

  const actModalSuccess = () => {
    setSuccessModalOpen(false);
    navigate({
      pathname: ROUTES.ALL_TRIP.LIST,
    });
  };

  const onClose = () => {
    setDetail([]);
    setDetailId();
    setOpenDetail(false);
  };
  return (
    <>
      <ModalDetail
        show={openDetail}
        onClose={() => onClose()}
        orderId={detailId}
        tripId={0}
        detail={detail}
      />
      <ModalConfirmLeave
        visible={showConfirm}
        action={() => setShowConfirm(false)}
        route={ROUTES.ALL_TRIP.LIST}
      />
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModalSuccess()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={"Your data has been added"}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <ModalFailedDelete
        show={isDetailModal}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be opened"
        description={messagesDetail}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>Order</Breadcrumb.Item>
            <Breadcrumb.Item>Routes</Breadcrumb.Item>
            <Breadcrumb.Item>All Trip</Breadcrumb.Item>
            <Breadcrumb.Item>Add All Trip</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <div className="flex items-center justify-between">
          <div
            onClick={
              change
                ? () => setShowConfirm(true)
                : () => navigate(ROUTES.ALL_TRIP.LIST)
            }
            className="flex items-center gap-[22px] cursor-pointer"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            <h1 className="font-sans-bold text-[28px]" id="title">
              Add All Trip
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <img
              src={page === 1 ? OrderLogo : page === 2 ? DelivLogo : ReviewLogo}
              alt="tab"
            />
            {/* <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            /> */}
            {!loading
              ? page === 1
                ? page1()
                : page === 2
                ? page2()
                : //         <div className={style.tableContainer}>
                  //   <CustomTable columns={ListColumn} data={dataSource} />
                  //   <div className={style.containerPagination + " mt-[-45px]"}>
                  //     <CustomPaging
                  //       idLimit="ddlrowsperpagemustselllist"
                  //       idPagination="btnpaginationmustselllist"
                  //       size="small"
                  //       current={page}
                  //       defaultCurrent={page}
                  //       pageSize={limit}
                  //       total={initiates && initiates?.count_data}
                  //       pageSizeOptions={initiates && initiates?.valid_limit}
                  //       onShowSizeChange={() => handlePagination()}
                  //       handlePaging={(a,b) => handlePagination(a,b)}
                  //       title={t("COMMON:ROW_PAGE")}
                  //     />
                  //   </div>
                  // </div>
                  page3()
              : "loading..."}
          </div>
        </div>

        <div className="flex flex-row-reverse gap-[16px]">
          {page === 1 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNext()}
              />
              <SecondaryButton
                action={
                  change
                    ? () => setShowConfirm(true)
                    : () => navigate(ROUTES.ALL_TRIP.LIST)
                }
                text={t("USER_DETAIL:CANCEL")}
              />
            </>
          ) : page === 2 ? (
            <>
              <PrimaryButton
                text={t("COMMON:NEXT")}
                action={() => handleNext2()}
              />
              <SecondaryButton text={t("Previous")} action={() => setPage(1)} />
            </>
          ) : (
            <>
              <PrimaryButton
                action={() => onSubmit()}
                text={t("USER_DETAIL:SAVE")}
              />
              <SecondaryButton text={t("Previous")} action={() => setPage(2)} />
            </>
          )}
          {/* <PrimaryButton text={t("COMMON:NEXT")} />
          <SecondaryButton text={t("USER_DETAIL:CANCEL")} /> */}
        </div>
      </div>
    </>
  );
};
export default AddAllTrip;
